import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-4 gap-4 -mb-4" }
const _hoisted_2 = {
  key: 0,
  class: "row-span-3 col-span-4 lg:col-span-3 space-y-3"
}
const _hoisted_3 = { class: "grid grid-cols-2 grid-rows-4 grid-flow-col gap-4" }
const _hoisted_4 = { class: "font-medium" }

import { // languages
		useI18n
	} from 'vue-i18n'

	import { // store
		localesStore as _localesStore
	} from '@/store/locales'

	import { // vue
		computed
	} from 'vue'
	
	
	const __default__ = { name: 'ContactInformation' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		contact: {
			type: Object,
			default: () => {return {}}
		},
		loading: {
			type: Boolean,
			default: false
		},
		contactType: {
			type: String,
			default: ""
		}
	},
  setup(__props) {

	const props = __props

	const localesStore = _localesStore()

	const {t} = useI18n()

	const deliveryOptions = computed(() => {
		let options = [
			{label: localesStore.getLabel('110'), checked: false}, // Email
			{label: localesStore.getLabel('796'), checked: false}, // Mail
			{label: localesStore.getLabel('733'), checked: false}, // Fax
			{label: localesStore.getLabel('797'), checked: false}, // Delivery
			{label: localesStore.getLabel('382'), checked: false} // Proof of Delivery
		]
		options.forEach(options => {
			if(props.contact?.fieldData?.["contact__CONTACTS_INFO__contactID::delivery_options"].includes(options.label)) {
				options.checked = true
			}
		})

		return options
	})

	const groupedRoles = computed(() => {
		if(
			props?.contact?.portalData?.portal_phone_numbers &&
			props?.contact?.portalData?.portal_emails) {
			return [
				// phone
				{subheading: localesStore.getLabel('561')},
				...props.contact.portalData.portal_phone_numbers,
				// email
				{subheading: localesStore.getLabel('110')},
				...props.contact.portalData.portal_emails
			]
		}
		else {
			return []
		}
	})

return (_ctx: any,_cache: any) => {
  const _component_tw_table_column = _resolveComponent("tw-table-column")!
  const _component_CheckIconMini = _resolveComponent("CheckIconMini")!
  const _component_MinusIconMini = _resolveComponent("MinusIconMini")!
  const _component_tw_table = _resolveComponent("tw-table")!
  const _component_data_display = _resolveComponent("data-display")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([__props.contactType == 'Staff' ? 'col-span-4 lg:col-span-3' : 'col-span-4 lg:col-span-2', ' w-full -mt-10 overflow-x-scroll border-b lg:border-b-0'])
    }, [
      _createVNode(_component_tw_table, {
        placeholder: _unref(t)('placeholders.noRoles'),
        data: groupedRoles.value,
        loading: __props.loading
      }, {
        default: _withCtx(() => [
          _createVNode(_component_tw_table_column, null, {
            default: _withCtx(({row}) => [
              _createTextVNode(_toDisplayString(row['contact__PHONES__contactID::phone_contact'] || row['contact__EMAILS__contactID::email_contact']), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_tw_table_column, null, {
            default: _withCtx(({row}) => [
              _createTextVNode(_toDisplayString(`${row['contact__PHONES__contactID::extension'] ? 'x' + row['contact__PHONES__contactID::extension'] : ''}`), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_tw_table_column, {
            header: _unref(localesStore).getLabel('1')
          }, {
            default: _withCtx(({row}) => [
              _createTextVNode(_toDisplayString(row['contact__PHONES__contactID::type_display'] || row['contact__EMAILS__contactID::type_display']), 1)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_tw_table_column, {
            header: _unref(localesStore).getLabel('292')
          }, {
            default: _withCtx(({row}) => [
              (row['contact__PHONES__contactID::primary'] ||
								row['contact__EMAILS__contactID::primary'])
                ? (_openBlock(), _createBlock(_component_CheckIconMini, {
                    key: 0,
                    class: "h-5 w-5 text-black"
                  }))
                : (_openBlock(), _createBlock(_component_MinusIconMini, {
                    key: 1,
                    class: "h-5 w-5 text-gray-300"
                  }))
            ]),
            _: 1
          }, 8, ["header"])
        ]),
        _: 1
      }, 8, ["placeholder", "data", "loading"])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass([__props.contactType == 'Staff' ? 'col-span-4 lg:col-span-1' : 'col-span-4 lg:col-span-2', 'pb-4'])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass([__props.contactType == 'Staff' ? 'grid-flow-row' : 'grid-flow-row lg:grid-flow-col', 'grid grid-cols-4 gap-4 lg:gap-6 px-4'])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass([__props.contactType == 'Staff' ? 'col-span-2 lg:col-span-4 row-span-1' : 'col-span-2 lg:col-span-1 row-span-1'])
        }, [
          _createVNode(_component_data_display, {
            label: _unref(localesStore).getLabel('14'),
            value: __props.contact?.fieldData?.line || '-' ,
            loading: __props.loading
          }, null, 8, ["label", "value", "loading"])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass([__props.contactType == 'Staff' ? 'col-span-2 lg:col-span-4 row-span-1' : 'col-span-2 lg:col-span-1 row-span-1'])
        }, [
          _createVNode(_component_data_display, {
            label: _unref(localesStore).getLabel('15'),
            value: __props.contact?.fieldData?.facebook || '-' ,
            loading: __props.loading
          }, null, 8, ["label", "value", "loading"])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass([__props.contactType == 'Staff' ? 'col-span-2 lg:col-span-4 row-span-1' : 'col-span-2 lg:col-span-1 row-span-1'])
        }, [
          _createVNode(_component_data_display, {
            label: _unref(localesStore).getLabel('16'),
            value: __props.contact?.fieldData?.url || '-' ,
            loading: __props.loading
          }, null, 8, ["label", "value", "loading"])
        ], 2),
        (__props.contactType == 'Client')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_data_display, {
                label: _unref(localesStore).getLabel('383')
              }, {
                custom: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deliveryOptions.value, (option) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: option.label,
                        class: _normalizeClass(["flex justify-start col-span-1 row-span-1 gap-2 items-center", {'opacity-30': !option.checked}])
                      }, [
                        (option.checked)
                          ? (_openBlock(), _createBlock(_component_CheckIconMini, {
                              key: 0,
                              class: "h-5 w-5"
                            }))
                          : (_openBlock(), _createBlock(_component_MinusIconMini, {
                              key: 1,
                              class: "h-5 w-5"
                            })),
                        _createElementVNode("span", _hoisted_4, _toDisplayString(option.label), 1)
                      ], 2))
                    }), 128))
                  ])
                ]),
                _: 1
              }, 8, ["label"])
            ]))
          : _createCommentVNode("", true)
      ], 2)
    ], 2)
  ]))
}
}

})